import i18n from '../src/i18n/i18n.js.erb'
import * as ably from 'ably'
import dailyIframe from '@daily-co/daily-js/dist/daily-iframe'

import '../src/shared/device-detector'
import '../src/shared/slide-in-menu-toggler'
import '../src/shared/intl-tel-inputs'
import '../src/personal-menu/personal-menu'
import '../src/pull-to-refresh/pull-to-refresh'
import '../src/content-filters'
import '../src/blurred-background-image'
import '../src/promote-pwa'
import '../src/profile-fields/file-field'
import './includes/invoice-addresses/autocomplete'

window.I18n = i18n
window.Ably = ably
window.DailyIframe = dailyIframe
